<app-call-logs-view
  [callLogs]="callLogs"
  [stats]="stats"
  [isLoading]="isLoading"
  [showTelecallerFilter]="false"
  [serverSideDateFiltering]="true"
  [serverSidePagination]="serverSidePagination"
  [totalRecords]="totalRecords"
  [pageSize]="pageSize"
  (dateRangeChange)="onDateRangeChange($event)"
  (pageChange)="onPageChange($event)"
  (refresh)="fetchCallLogs()"
></app-call-logs-view>
